export enum LanguageEnum {
  Turkish = 1,
  English = 2,
  Russian = 3,
}
